import { FC, PropsWithChildren, ReactNode } from 'react'
import { TooltipWrapper } from '@wellesley/ui'
import * as TooltipPrimitive from '@radix-ui/react-tooltip'

type TooltipProps = PropsWithChildren<{
  tooltipText: ReactNode
  triggerProps?: TooltipPrimitive.TooltipTriggerProps
  contentProps?: TooltipPrimitive.TooltipContentProps
}>

const CustomTooltip: FC<TooltipProps> = ({
  tooltipText,
  children,
  triggerProps,
  contentProps,
}) => {
  return (
    <div className="max-w-full truncate [&>button]:block [&>button]:max-w-full [&>button]:truncate">
      <TooltipWrapper
        size="default"
        theme="dark"
        tooltipText={tooltipText}
        triggerProps={triggerProps}
        {...contentProps}
      >
        {children}
      </TooltipWrapper>
    </div>
  )
}

export default CustomTooltip
